import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { Button, Drawer } from '../../../atoms';
import { planManagementDrawer_style } from './style';

function PlanManagementDrawer(props) {
  const {
    className = '',
    header = '',
    drawerOpen,
    closeDrawer = () => {},
    upsertUser = () => {},
    children,
    loading,
    rootStyle = {},
    isUpdate = false,
    ...rest
  } = props;

  return (
    <Box
      sx={{
        ...planManagementDrawer_style.rootSx,
        ...rootStyle,
      }}
      className={`${className}`}
      {...rest}
    >
      <Box>
        {drawerOpen && (
          <Drawer
            show={drawerOpen}
            onCloseDrawer={closeDrawer}
            anchor="right"
            isCloseIconRequired
            header={header}
            headerStyle={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#101010',
              textTransform: 'capitalize',
            }}
            footerStyle={{
              borderTop: '0px',
              py: 2.8,
              px: 2,
              // position: 'static',
            }}
            footer={
              <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                }}
              >
                <Button
                  loading={loading}
                  buttonStyle={{
                    bgcolor: 'primary.main',
                    textTransform: 'capitalize',
                    color: '#fff',
                    borderRadius: '8px',
                    '&:hover': {
                      bgcolor: 'primary.main',
                    },
                  }}
                  onClick={() => upsertUser()}
                >
                  {isUpdate ? 'Update' : 'Save'}
                </Button>
                <Button
                  disabled={loading === true ? true : false}
                  buttonStyle={{
                    border: '1px solid',
                    borderColor: 'primary.main',
                    color: 'primary.main',
                    textTransform: 'capitalize',
                    borderRadius: '8px',
                    bgcolor: '#fff',
                    '&:hover': {
                      bgcolor: 'primaryTints.200',
                    },
                  }}
                  onClick={closeDrawer}
                >
                  Cancel
                </Button>
              </Box>
            }
          >
            {children}
          </Drawer>
        )}
      </Box>
    </Box>
  );
}

PlanManagementDrawer.propTypes = {
  className: PropTypes.string,
  header: PropTypes.string,
  rootStyle: PropTypes.object,
  drawerOpen: PropTypes.bool,
  closeDrawer: PropTypes.func,
  upsertUser: PropTypes.func,
  loading: PropTypes.bool,
  children: PropTypes.element,
};

export { PlanManagementDrawer };
